import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '../../IconButton/IconButton';
import styles from './ShareButton.scss';
import { ShareIcon } from './ShareIcon';
import { ShareQueryParameter } from '../../../constants/social';
import { generateUrlWithShareParameter } from '../../../utils/generateUrlWithShareParameter';
import { usePageMeta } from '../../../hooks';
import { ShareModal } from '../../ShareModal/ShareModal';
import { TimelineShare } from '../../SocialButtons/TimelineShare';

interface ShareButtonProps {
  disabled?: boolean;
  timelineImage?: string;
  description?: string | null;
}

const ShareButton: FunctionComponent<ShareButtonProps> = ({
  disabled = false,
  timelineImage,
  description,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const [isOpen, setOpen] = useState(false);
  const { currentUrl } = usePageMeta();

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const metaTagValues: ShareQueryParameter = {
    ogImageUrl: timelineImage?.split('?')[0],
    ogDescription: description || undefined,
  };

  const shareUrl = generateUrlWithShareParameter(currentUrl, metaTagValues);

  return (
    <>
      <IconButton
        className={`${styles.shareButton} ${disabled ? 'disabled' : ''}`}
        disabled={disabled}
        onClick={openModal}
        aria-label={t('timeline.shareButton')}
      >
        <ShareIcon className={styles.icon} />
      </IconButton>
      {isOpen && (
        <TimelineShare shareUrl={shareUrl} description={description}>
          <ShareModal
            heading={t('timeline.shareModalTitle')}
            description={t('timeline.shareModalMessage')}
            onClose={closeModal}
          />
        </TimelineShare>
      )}
    </>
  );
};

export default ShareButton;
